import { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { bulkDeleteOwners } from 'store/owners/actions'
import type { BulkDeleteOwnersResponse } from 'store/owners/types'

export interface UseBulkDeleteOwnersResult {
  bulkDeleteOwners: (ownerIds: string[]) => Promise<{ success: boolean; data?: BulkDeleteOwnersResponse; error?: any }>
  isLoading: boolean
}

export const useBulkDeleteOwners = (): UseBulkDeleteOwnersResult => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const handleBulkDeleteOwners = useCallback(async (ownerIds: string[]): Promise<{ success: boolean; data?: BulkDeleteOwnersResponse; error?: any }> => {
    setIsLoading(true)
    
    return new Promise((resolve) => {
      dispatch(bulkDeleteOwners(
        { ownerIds },
        (result: { success: boolean; data?: BulkDeleteOwnersResponse; error?: any }) => {
          setIsLoading(false)
          resolve(result)
        }
      ))
    })
  }, [dispatch])

  return {
    bulkDeleteOwners: handleBulkDeleteOwners,
    isLoading,
  }
}
